var map = {
	"./1_x1.png": 16985,
	"./1_x2.png": 2978,
	"./1_x4.png": 90996,
	"./1_x7.png": 13455,
	"./2_x2.png": 20603,
	"./2_x4.png": 45389,
	"./2_x6.png": 67423,
	"./2_x8.png": 52401,
	"./3_x12.png": 35645,
	"./3_x3.png": 6829,
	"./3_x6.png": 38464,
	"./3_x9.png": 39559,
	"./4_x12.png": 49030,
	"./4_x16.png": 25986,
	"./4_x4.png": 82699,
	"./4_x8.png": 7479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31496;